<template>
    <v-app id="portal" :dark="darkTheme">
        <v-content>
            <v-container fluid fill-height>
                <router-view></router-view>
                <snackbar />
                <session-notice-modal v-if="isLoggedIn" />
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import SessionNoticeModal from "@/components/SessionNoticeModal";
import Snackbar from "@/components/Snackbar";

export default {
    data () {
        return {
            darkTheme: false,
        };
    },

    components: {
        SessionNoticeModal,
        Snackbar,
    },

    computed: {
        isLoggedIn() {
            return this.$store.state.auth.access_token;
        },
    },

    created() {
        this.$store.dispatch("startSessionTimer");
    },
};
</script>

<style lang="scss">
    @import "~vuetify/dist/vuetify.min.css";

    $blue: #001E60;
    $red: #C8102E;

    #portal {
        background-color: $blue;
    }
</style>
